/** Shared boundary for form input, restored charts and direct engine calls. */
export function validateBirthDateTime(date: string, time: string, lunar = false) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) throw new RangeError('Birth date must use YYYY-MM-DD / 出生日期须为 YYYY-MM-DD');
  if (!/^\d{2}:\d{2}(?::\d{2})?$/.test(time)) throw new RangeError('Birth time must use HH:MM[:SS] / 请填写完整出生时间');
  const [year, month, day] = date.split('-').map(Number);
  const [hour, minute, second = 0] = time.split(':').map(Number);
  if (year < 1900 || year > 2100 || month < 1 || month > 12 || day < 1 || day > (lunar ? 30 : 31) || hour > 23 || minute > 59 || second > 59) {
    throw new RangeError('Invalid birth date/time (supported years: 1900–2100) / 出生日期或时间无效');
  }
  const utc = Date.UTC(year, month - 1, day, hour, minute, second);
  if (!lunar && new Date(utc).getUTCDate() !== day) throw new RangeError('Date does not exist / 该日期不存在');
  return { year, month, day, hour, minute, second, utc };
}
